export enum OrderItemStatusEnum {
    NEW = 'NEW', // НОВЫЙ
    PREPAYMENT_REQUIRED = 'PREPAYMENT_REQUIRED', // ТРЕБУЕТСЯ ПРЕДОПЛАТА
    RESERVED = 'RESERVED', // ЗАРЕЗЕРВИРОВАН
    DELIVERY = 'DELIVERY', // ДОСТАВКА
    COMPLETED = 'COMPLETED', // ЗАВЕРШЕННЫЙ
    CANCELED = 'CANCELED', // ОТМЕНЕНО
    TRASH = 'TRASH',
}
